import React from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SettingRow,
  Switch,
} from "@coval/ui"

import { CustomSipHeadersField } from "@/components/shared/forms/CustomSipHeadersField"
import { FieldLabel } from "@/components/shared/forms/FieldLabel"
import { useSipHeadersJson } from "@/hooks/useSipHeadersJson"
import {
  isMediaEncryptionValue,
  MediaEncryption,
} from "@/types/api/SimulatorType"

interface SipAdvancedFieldsProps {
  widebandEnabled?: boolean
  onWidebandChange?: (enabled: boolean) => void
  customSipHeaders?: string
  onCustomSipHeadersChange?: (value: string) => void
  mediaEncryption?: string
  onMediaEncryptionChange?: (value: string) => void
  disabled?: boolean
}

const MEDIA_ENCRYPTION_OPTIONS = [
  { label: "Disabled", value: MediaEncryption.DISABLED },
  { label: "SRTP", value: MediaEncryption.SRTP },
  { label: "DTLS", value: MediaEncryption.DTLS },
] as const

export const SipAdvancedFields: React.FC<SipAdvancedFieldsProps> = ({
  widebandEnabled,
  onWidebandChange,
  customSipHeaders,
  onCustomSipHeadersChange,
  mediaEncryption,
  onMediaEncryptionChange,
  disabled,
}) => {
  const parsedSipHeaders = useSipHeadersJson(customSipHeaders)
  const mediaEncryptionSelectValue =
    mediaEncryption == null || isMediaEncryptionValue(mediaEncryption)
      ? (mediaEncryption ?? MediaEncryption.DISABLED)
      : ""

  return (
    <div className="space-y-4">
      {onWidebandChange && (
        <SettingRow label="Wideband Audio (16kHz)">
          {(controlId) => (
            <Switch
              id={controlId}
              checked={widebandEnabled ?? false}
              onCheckedChange={onWidebandChange}
              disabled={disabled}
            />
          )}
        </SettingRow>
      )}
      {onMediaEncryptionChange && (
        <div className="space-y-2">
          <FieldLabel>Media Encryption</FieldLabel>
          <Select
            value={mediaEncryptionSelectValue}
            onValueChange={onMediaEncryptionChange}
            disabled={disabled}
          >
            <SelectTrigger aria-label="Media Encryption">
              <SelectValue
                placeholder={
                  mediaEncryptionSelectValue === ""
                    ? "Unsupported saved value; choose a replacement"
                    : undefined
                }
              />
            </SelectTrigger>
            <SelectContent>
              {MEDIA_ENCRYPTION_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      {onCustomSipHeadersChange && (
        <CustomSipHeadersField
          value={parsedSipHeaders}
          onChange={onCustomSipHeadersChange}
        />
      )}
    </div>
  )
}
